import * as reportsAPI from '../api/reports'
import * as types      from "../mutation-types"
import moment          from "moment/moment.js"

// initial state
const reports = {
    namespace: 'reports',
    state: {
        company: 'CF',
        start_date: moment().set('month', 8).set('date', 1).format('Y-MM-DD'),
        end_date: moment().format('Y-MM-DD'),
    },
    getters: {
        reportCompany: (state) => state.company,
        reportStartDate: (state) => state.start_date,
        reportEndDate: (state) => state.end_date,
    },
    mutations: {
        [types.SET_REPORT_COMPANY]: (state, company) => {
            state.company = company
        },
        [types.SET_REPORT_START]: (state, start) => {
            state.start_date = start
        },
        [types.SET_REPORT_END]: (state, end) => {
            state.end_date = end
        }
    },

    actions: {
        [types.SET_REPORT_COMPANY]: ({commit, dispatch, state}, company) => {
            commit(types.SET_REPORT_COMPANY, company)
        },
        [types.SET_REPORT_START]: ({commit, dispatch, state}, start) => {
            commit(types.SET_REPORT_START, start)
        },
        [types.SET_REPORT_END]: ({commit, dispatch, state}, end) => {
            commit(types.SET_REPORT_END, end)
        }
    },
};

export default reports;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/reports/index.js
// module id = 621
// module chunks = 0